/* global gtag_report_conversion */
import React, { Component } from 'react';
import { HashLink } from 'react-router-hash-link';

class About extends Component {
    constructor(props){
        super(props);
        this.state = {
            // Tu contenido original en español
            about: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Obtén esta guía práctica ¡Disponible en Amazone KDP!',
                    text: 'La innovación y la calidad, respaldan este proyecto'
                },
                {
                    id: 2,
                    icon: 'bi bi-support',
                    title: 'Disponible en hardcover y paperback',
                    text: 'Accede a ejemplos prácticos desde la web del libro'
                },
                {
                    id: 3,
                    icon: 'bi bi-rocket2',
                    title: 'Impulsa tus objetivos',
                    text: 'Diseñado para ayudarte a alcanzar tus metas de aprendizaje y crecimiento profesional'
                }
            ],

            // Enlaces de Amazon por país
            amazonLinks: [
                { country: "US", url: "https://www.amazon.com/dp/840976203X?maas=maas_adg_5D3B5D476A41185CD9D0075ED74588D7_afap_abs&ref_=aa_maas&tag=maas", flag: "us.png", currency: "USD" },
                { country: "UK", url: "https://www.amazon.co.uk/dp/840976203X?maas=maas_adg_2380B854318D3EC709F4400CCB2BCD7E_afap_abs&ref_=aa_maas&tag=maas", flag: "gb.png", currency: "GBP" },
                { country: "DE", url: "https://www.amazon.de/dp/840976203X?maas=maas_adg_8A4A1243AF9226603BB25D99FCE73166_afap_abs&ref_=aa_maas&tag=maas", flag: "de.png", currency: "EUR" },
                { country: "FR", url: "https://www.amazon.fr/dp/840976203X?maas=maas_adg_375099402E9609BC757AE5AD99A16277_afap_abs&ref_=aa_maas&tag=maas", flag: "fr.png", currency: "EUR" },
                { country: "ES", url: "https://www.amazon.es/dp/840976203X?maas=maas_adg_6A720AC813E1AD9C76ADB9263BD33E21_afap_abs&ref_=aa_maas&tag=maas", flag: "es.png", currency: "EUR" },
                { country: "IT", url: "https://www.amazon.it/dp/840976203X?maas=maas_adg_B098D7F6010D669676C96BF73637DA59_afap_abs&ref_=aa_maas&tag=maas", flag: "it.png", currency: "EUR" },
                { country: "NL", url: "https://www.amazon.nl/dp/840976203X?maas=maas_adg_3D8D899491E1FFD5D27F4425F387FC92_afap_abs&ref_=aa_maas&tag=maas", flag: "nl.png", currency: "EUR" },
                { country: "PL", url: "https://www.amazon.pl/dp/840976203X", flag: "pl.png", currency: "PLN" },
                { country: "SE", url: "https://www.amazon.se/dp/840976203X", flag: "se.png", currency: "SEK" },
                { country: "JP", url: "https://www.amazon.co.jp/dp/840976203X", flag: "jp.png", currency: "JPY" },
                { country: "CA", url: "https://www.amazon.ca/dp/840976203X?maas=maas_adg_7EC09E874A5E5EECA12B0FB8A943209D_afap_abs&ref_=aa_maas&tag=maas", flag: "ca.png", currency: "CAD" },
                { country: "AU", url: "https://www.amazon.com.au/dp/840976203X", flag: "au.png", currency: "AUD" },
            ],

            showDropdown: false
        };

        this.dropdownRef = React.createRef();
    }

    // Se ejecuta al montar el componente
    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    // Limpieza de eventos al desmontar
    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    // Cierra el menú si se hace clic fuera
    handleDocumentClick = (e) => {
        if (!this.dropdownRef.current) return;
        if (this.state.showDropdown && !this.dropdownRef.current.contains(e.target)) {
            this.setState({ showDropdown: false });
        }
    };

    // Cierra el menú con la tecla Escape
    handleKeyDown = (e) => {
        if (e.key === 'Escape' && this.state.showDropdown) {
            this.setState({ showDropdown: false });
        }
    };

    // Alterna el estado del menú
    toggleDropdown = (e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        this.setState(prev => ({ showDropdown: !prev.showDropdown }));
    };

    handleAmazonClick = async (link, e) => {
      try {
        // URL dinámica para desarrollo y producción
        const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
          ? 'https://controlbook.onrender.com'
          : 'http://localhost:3000';
    
        await fetch(`${backendUrl}/clicks`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: "session-" + Math.random().toString(36).substr(2, 9),
            elementId: "masinfo-" + link.country.toLowerCase(),
            pageUrl: window.location.href,
            elementType: "link",
            userId: "user-react",
            coordinates: { x: 100, y: 200 },
            metadata: {
              country: link.country,
              currency: link.currency,
              store: "amazon",
              product: "neural-networks-book"
            }
          }),
        });
      } catch (err) {
        console.error('Error recording click', err);
      }
    
      // Analytics
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-16832649503/ItwECMuR6ZIbEJ-yt9o-",
          value: 1.0,
          currency: link.currency,
        });
      }
      
      this.setState({ showDropdown: false });
    };

    render() {
        return (
            <section className="about-section section-padding dark-bg-light" id="about">
                <div className="container">
                    <div className="row">
                        {/* Imagen lateral */}
                        <div className="col-lg-6 col-md-6">
                            <div className="about-img">
                                <img src="assets/images/banner/book-2.png" alt="Libro" className="img-fluid"/>
                            </div>
                        </div>

                        {/* Contenido principal */}
                        <div className="col-lg-6 col-md-6">
                            <div className="section-heading">
                                <span className="subheading">10% de descuento por compra anticipada</span>
                                <h3 className="heading-title">Todo al alcance de tu mano</h3>
                                <p>Este libro, cuidadosamente escrito, es una referencia imprescindible para profesionales.</p>
                            </div>

                            {/* Bloques informativos */}
                            {this.state.about.map((data, i) => (
                                <div className="about-text-block" key={i}>
                                    <i className={data.icon}></i>
                                    <h4>{data.title}</h4>
                                    <p>{data.text}</p>
                                </div>
                            ))}

                            {/* Dropdown de Amazon */}
                            <div className="dropdown mt-4" ref={this.dropdownRef}>
                                <button
                                    className="btn btn-main-2 dropdown-toggle"
                                    type="button"
                                    aria-haspopup="true"
                                    aria-expanded={this.state.showDropdown}
                                    onClick={this.toggleDropdown}
                                >
                                    <i className="fa fa-check me-2"></i>Más Información
                                </button>

                                <div
                                    className={`dropdown-menu ${this.state.showDropdown ? 'show' : ''}`}
                                    style={{ maxHeight: 300, overflowY: 'auto' }}
                                >
                                    {this.state.amazonLinks.map((link) => (
                                        <a
                                            key={link.country}
                                            href={link.url}
                                            className="dropdown-item d-flex align-items-center"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={(e) => this.handleAmazonClick(link, e)}
                                        >
                                            <img
                                                src={`https://flagcdn.com/w20/${link.flag}`}
                                                alt={link.country}
                                                style={{ width: 20, marginRight: 8 }}
                                            />
                                            <span>Amazon {link.country}</span>
                                        </a>
                                    ))}
                                </div>
                            </div>

                            {/* Enlace adicional */}
                            <p className="mt-3">
                              ¿Quieres leer un capítulo gratuito?{" "}
                              <a
                                href="/preview_merged_sp.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(event) => {
                                  // URL dinámica para desarrollo y producción
                                  const backendUrl = window.location.hostname === 'neuralnetadaptivecontrol.com' 
                                    ? 'https://controlbook.onrender.com'
                                    : 'http://localhost:3000';
                            
                                  // Trackear el click
                                  fetch(`${backendUrl}/clicks`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                      sessionId: "session-" + Math.random().toString(36).substr(2, 9),
                                      elementId: "capitulo-gratuito",
                                      pageUrl: window.location.href,
                                      elementType: "link", 
                                      userId: "user-react",
                                      coordinates: { x: event.clientX, y: event.clientY },
                                      metadata: {
                                        document: "preview_merged.pdf",
                                        type: "free-chapter",
                                        action: "download"
                                      }
                                    }),
                                  }).catch(err => console.error('Error tracking click:', err));
                            
                                }}
                              >
                                Descárgalo ahora
                              </a>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;
